import data from './data.js';

/**
 * Get verbiage for a specific error code and language, replacing placeholders with provided parameters.
 *
 * @param {string} errorCode - The error code for which verbiage is needed.
 * @param {string} [language='en'] - The language in which the verbiage should be retrieved (default is 'en').
 * @param {string[]} [params=[]] - An array of parameters to replace placeholders in the verbiage (default is an empty array).
 * @param skipErrorCode
 * @returns {string} The verbiage with placeholders replaced by the provided parameters, including the error code.
 */
function getVerbiage(errorCode, language = 'en', params = [], skipErrorCode = false) {
  if (!data[errorCode]) {
    throw `Failed to find the specified error code: ${errorCode}`;
  }
  let str = data[errorCode].verbiage[language];

  // loop over the params and replace the template string with the parameter
  // eslint-disable-next-line array-callback-return
  params.map((param, i) => {
    str = str.replace(`params[${i}]`, param);
  });
  if (!skipErrorCode) {
    str += ` (${errorCode})`;
  }
  return str;
}
export default getVerbiage;